import { useQuery } from "@tanstack/react-query";
import { moveShelf } from "../repositories/ShelvesRepository";

/** What the move would do, from the same procedure that applies it. A null code takes the suggested one. */
export const useShelfMovePreview = (
	treeId: number | null,
	newParentTreeId: number | null,
	newCode: string | null,
	enabled: boolean,
) => {
	return useQuery({
		queryKey: ["shelves", "movePreview", treeId, newParentTreeId, newCode],
		queryFn: ({ signal }) =>
			moveShelf(
				treeId as number,
				newParentTreeId as number,
				newCode,
				false,
				null,
				signal,
			),
		enabled: enabled && treeId !== null && newParentTreeId !== null,
		keepPreviousData: true,
		staleTime: 0,
	});
};
